/**
 * Walkthrough related commands
 */

import {isUserLoggedIn} from "@Libraries/user.library.ts";

let CMDS;

export default (opt = {}) => {

    let editor = opt.editor,
        cmds = editor.Commands;

    CMDS = window.PMW.emails.commands;

    cmds.add(CMDS.walkthrough.GET_NON_LOGGED_IN_USER_SEEN_WALKTHROUGH_, async (editor, opts) => {
        window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.userHasSeen = PMW.getCacheItem(window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name) === '1';
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen = PMW.getCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.name) === '1';
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen = PMW.getCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.name) === '1';
        window.PMW.emails.walkthrough.ADD_SECTION.userHasSeen = PMW.getCacheItem(window.PMW.emails.walkthrough.ADD_SECTION.name) === '1';
        window.PMW.emails.walkthrough.ADD_TABLE.userHasSeen = PMW.getCacheItem(window.PMW.emails.walkthrough.ADD_TABLE.name) === '1';
        window.PMW.emails.walkthrough.ADD_BUTTON.userHasSeen = PMW.getCacheItem(window.PMW.emails.walkthrough.ADD_BUTTON.name) === '1';
        window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.userHasSeen = PMW.getCacheItem(window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.name) === '1';
        window.PMW.emails.walkthrough.ADD_LINK.userHasSeen = PMW.getCacheItem(window.PMW.emails.walkthrough.ADD_LINK.name) === '1';
        window.PMW.emails.walkthrough.ADD_DESIGN.userHasSeen = PMW.getCacheItem(window.PMW.emails.walkthrough.ADD_DESIGN.name) === '1';
    });


    cmds.add(CMDS.walkthrough.GET_USER_SEEN_WALKTHROUGH, async (editor, opts) => {
        if (isUserLoggedIn()) {
            await editor.runCommand(window.PMW.emails.commands.walkthrough.GET_USER_LOGGED_IN_SEEN_WALKTHROUGH);
        } else {
            await editor.runCommand(window.PMW.emails.commands.walkthrough.GET_NON_LOGGED_IN_USER_SEEN_WALKTHROUGH_);
        }
    });

    cmds.add(CMDS.walkthrough.GET_USER_LOGGED_IN_SEEN_WALKTHROUGH, async (editor, opts) => {
        try {
            const userHasSeen = await PMW.readLocal('emailmaker/getUserHasSeenWalkthrough');
            window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.userHasSeen = userHasSeen.userMainWalkthrough;
            window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen = userHasSeen.userWalkthroughHierarchyLevelOne;
            window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen = userHasSeen.userWalkthroughHierarchyLevelTwo;
            window.PMW.emails.walkthrough.ADD_SECTION.userHasSeen = userHasSeen.userWalkthroughSection;
            window.PMW.emails.walkthrough.ADD_TABLE.userHasSeen = userHasSeen.userWalkthroughTable;
            window.PMW.emails.walkthrough.ADD_BUTTON.userHasSeen = userHasSeen.userWalkthroughButton;
            window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.userHasSeen = userHasSeen.userWalkthroughSocial;
            window.PMW.emails.walkthrough.ADD_LINK.userHasSeen = userHasSeen.userWalkthroughLink;
            window.PMW.emails.walkthrough.ADD_DESIGN.userHasSeen = userHasSeen.userWalkthroughDesign;
        } catch (e) {
            console.error('User has seen does not exist for this user id');
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_USER_INTRODUCTION_MAIN_WALKTHROUGH_POPUP, (editor, opts) => {
        if (!window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughIntroductionContainer(window.PMW.emails.walkthrough.INTRODUCTION_MAIN_WALKTHROUGH.name);
            PMW.load(
                getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.INTRODUCTION_MAIN_WALKTHROUGH.name),
                PMW.util.site_url('emailmaker/userMainWalkthroughIntroductionPopup/' + window.PMW.emails.walkthrough.INTRODUCTION_MAIN_WALKTHROUGH.name), {},
                initialiseStartWalkThroughListeners
            );
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_USER_MAIN_WALKTHROUGH_POPUP, (editor, opts) => {
        if (!window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughContainer(window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name);
            window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = true;
            PMW.load(getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name), PMW.util.site_url('emailmaker/userMainWalkthroughPopup/' + window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name), {
                isAutosaveEnabled: editor.StorageManager.isAutosave()
            }, function (id, options) {
                initialiseWalkThroughListeners(window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name);
                initialiseFirstPopupDimensionsAndPosition(window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name);
                editor.runCommand(window.PMW.emails.commands.DISABLE_EDITOR_CONTROLS, options);
            });
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_ADD_SECTION_WALKTHROUGH_POPUP, (editor, opts) => {
        if (!window.PMW.emails.walkthrough.ADD_SECTION.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughContainer(window.PMW.emails.walkthrough.ADD_SECTION.name);
            window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = true;
            PMW.load(getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.ADD_SECTION.name), PMW.util.site_url('emailmaker/openAddSectionWalkThroughPopup'), {
                isHierarchyLevelOne: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: false,
                isLink: false,
                walkthroughType: window.PMW.emails.walkthrough.ADD_SECTION.name
            }, function (id, options) {
                initialiseWalkThroughListeners(window.PMW.emails.walkthrough.ADD_SECTION.name);
                initialiseFirstPopupDimensionsAndPosition(window.PMW.emails.walkthrough.ADD_SECTION.name);
                editor.runCommand(window.PMW.emails.commands.DISABLE_EDITOR_CONTROLS, options);
            });
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_ADD_TABLE_WALKTHROUGH_POPUP, (editor, opts) => {
        if (!window.PMW.emails.walkthrough.ADD_TABLE.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughContainer(window.PMW.emails.walkthrough.ADD_TABLE.name);
            window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = true;
            PMW.load(getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.ADD_TABLE.name), PMW.util.site_url('emailmaker/openAddTableWalkThroughPopup'), {
                isHierarchyLevelOne: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: false,
                isLink: false,
                walkthroughType: window.PMW.emails.walkthrough.ADD_TABLE.name
            }, function (id, options) {
                initialiseWalkThroughListeners(window.PMW.emails.walkthrough.ADD_TABLE.name);
                initialiseFirstPopupDimensionsAndPosition(window.PMW.emails.walkthrough.ADD_TABLE.name);
                editor.runCommand(window.PMW.emails.commands.DISABLE_EDITOR_CONTROLS, options);
            });
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_ADD_BUTTON_WALKTHROUGH_POPUP, (editor, opts) => {
        if (!window.PMW.emails.walkthrough.ADD_BUTTON.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughContainer(window.PMW.emails.walkthrough.ADD_BUTTON.name);
            window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = true;
            PMW.load(getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.ADD_BUTTON.name), PMW.util.site_url('emailmaker/openAddButtonsWalkThroughPopup'), {
                isHierarchyLevelOne: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen,
                isLink: !window.PMW.emails.walkthrough.ADD_LINK.userHasSeen,
                walkthroughType: window.PMW.emails.walkthrough.ADD_BUTTON.name
            }, function (id, options) {
                initialiseWalkThroughListeners(window.PMW.emails.walkthrough.ADD_BUTTON.name);
                initialiseFirstPopupDimensionsAndPosition(window.PMW.emails.walkthrough.ADD_BUTTON.name);
                editor.runCommand(window.PMW.emails.commands.DISABLE_EDITOR_CONTROLS, options);
            });
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_ADD_SOCIAL_LINKS_WALKTHROUGH_POPUP, (editor, opts) => {
        if (!window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughContainer(window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.name);
            window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = true;
            PMW.load(getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.name), PMW.util.site_url('emailmaker/openAddSocialLinksWalkThroughPopup'), {
                isHierarchyLevelOne: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen,
                isLink: false,
                walkthroughType: window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.name
            }, function (id, options) {
                initialiseWalkThroughListeners(window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.name);
                initialiseFirstPopupDimensionsAndPosition(window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.name);
                editor.runCommand(window.PMW.emails.commands.DISABLE_EDITOR_CONTROLS, options);
            });
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_ADD_DESIGN_WALKTHROUGH_POPUP, (editor, opts) => {
        if (!window.PMW.emails.walkthrough.ADD_DESIGN.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughContainer(window.PMW.emails.walkthrough.ADD_DESIGN.name);
            window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = true;
            PMW.load(getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.ADD_DESIGN.name), PMW.util.site_url('emailmaker/openAddDesignWalkThroughPopup'), {
                isHierarchyLevelOne: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen,
                isLink: !window.PMW.emails.walkthrough.ADD_LINK.userHasSeen,
                walkthroughType: window.PMW.emails.walkthrough.ADD_DESIGN.name
            }, function (id, options) {
                initialiseWalkThroughListeners(window.PMW.emails.walkthrough.ADD_DESIGN.name);
                initialiseFirstPopupDimensionsAndPosition(window.PMW.emails.walkthrough.ADD_DESIGN.name);
                editor.runCommand(window.PMW.emails.commands.DISABLE_EDITOR_CONTROLS, options);
            });
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_ADD_LINK_WALKTHROUGH_POPUP, (editor, sender, opts) => {
        if (!window.PMW.emails.walkthrough.ADD_LINK.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughContainer(window.PMW.emails.walkthrough.ADD_LINK.name);
            window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = true;
            PMW.load(getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.ADD_LINK.name), PMW.util.site_url('emailmaker/openAddLinkWalkThroughPopup'), {
                isHierarchyLevelOne: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen,
                isLink: !window.PMW.emails.walkthrough.ADD_LINK.userHasSeen,
                walkthroughType: window.PMW.emails.walkthrough.ADD_LINK.name
            }, function (id, options) {
                initialiseWalkThroughListeners(window.PMW.emails.walkthrough.ADD_LINK.name);
                initialiseFirstPopupDimensionsAndPosition(window.PMW.emails.walkthrough.ADD_LINK.name);
                editor.runCommand(window.PMW.emails.commands.DISABLE_EDITOR_CONTROLS, options);
            });
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_ADD_STICKER_WALKTHROUGH_POPUP, (editor, opts) => {
        if (!window.PMW.emails.walkthrough.ADD_LINK.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughContainer(window.PMW.emails.walkthrough.ADD_LINK.name);
            window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = true;
            PMW.load(getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.ADD_LINK.name), PMW.util.site_url('emailmaker/openAddStickerWalkThroughPopup'), {
                isHierarchyLevelOne: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen,
                isLink: !window.PMW.emails.walkthrough.ADD_LINK.userHasSeen,
                walkthroughType: window.PMW.emails.walkthrough.ADD_LINK.name
            }, function (id, options) {
                initialiseWalkThroughListeners(window.PMW.emails.walkthrough.ADD_LINK.name);
                initialiseFirstPopupDimensionsAndPosition(window.PMW.emails.walkthrough.ADD_LINK.name);
                editor.runCommand(window.PMW.emails.commands.DISABLE_EDITOR_CONTROLS, options);
            });
        }
    });

    cmds.add(CMDS.walkthrough.OPEN_ADD_VIDEO_WALKTHROUGH_POPUP, (editor, opts) => {
        if (!window.PMW.emails.walkthrough.ADD_LINK.userHasSeen && !isWalkThroughPopupOpen()) {
            initialiseWalkthroughContainer(window.PMW.emails.walkthrough.ADD_LINK.name);
            window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = true;
            PMW.load(getWalkthroughHtmlContainer(window.PMW.emails.walkthrough.ADD_LINK.name), PMW.util.site_url('emailmaker/openAddVideoWalkThroughPopup'), {
                isHierarchyLevelOne: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: !window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen,
                isLink: !window.PMW.emails.walkthrough.ADD_LINK.userHasSeen,
                walkthroughType: window.PMW.emails.walkthrough.ADD_LINK.name
            }, function (id, options) {
                initialiseWalkThroughListeners(window.PMW.emails.walkthrough.ADD_LINK.name);
                initialiseFirstPopupDimensionsAndPosition(window.PMW.emails.walkthrough.ADD_LINK.name);
                editor.runCommand(window.PMW.emails.commands.DISABLE_EDITOR_CONTROLS, options);
            });
        }
    });

    cmds.add(CMDS.DISABLE_EDITOR_CONTROLS, (editor, opts) => {
        $('.js-blocks-manager')[0].style.pointerEvents = 'none';
        $('.html-editor-canvas-box')[0].style.pointerEvents = 'none';
    });

    cmds.add(CMDS.ENABLE_EDITOR_CONTROLS, (editor, opts) => {
        $('.js-blocks-manager')[0].style.pointerEvents = 'UNSET';
        $('.html-editor-canvas-box')[0].style.pointerEvents = 'UNSET';
    });

    /**
     *
     * @param {string} walkthroughType
     * @returns {*}
     */
    function getWalkthroughHtmlContainer(walkthroughType) {
        return $(window.PMW.emails.WALKTHROUGH_CONTAINER_CLASSNAME + '.' + walkthroughType)
    }

    function isWalkThroughPopupOpen() {
        return $('.user-walkthrough-popup:visible').length > 0 || window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN;
    }

    /**
     *
     * @param {string} walkthroughType
     */
    function initialiseFirstPopupDimensionsAndPosition(walkthroughType) {
        let mainContainer = $('.user-walkthrough-popup' + '.' + walkthroughType + ':visible'),
            currentWalkThroughElement = mainContainer.find('.walkthrough-container').not('._hidden');
        try {
            handleFirstStepWalkthrough(true);
            changePositionAndDimensionsOfPopup(mainContainer, currentWalkThroughElement);
        } catch (e) {
            console.error(e);
            disableUserWalkThrough(walkthroughType);
        }
    }

    /**
     *
     * @param {string} containerClassName
     */
    function initialiseWalkthroughIntroductionContainer(containerClassName) {
        const mainContainer = document.querySelector('body'),
            walkthroughContainer = document.createElement('div'),
            hiddenForPhone = containerClassName !== window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name && containerClassName !== window.PMW.emails.walkthrough.INTRODUCTION_MAIN_WALKTHROUGH.name ? 'hidden-tablet hidden-phone' : '';

        mainContainer.classList.add('walkthrough');
        walkthroughContainer.id = 'email-editor-walkthrough-container ' + containerClassName;
        walkthroughContainer.className = 'js-walkthrough-container ' + containerClassName + '  ' + hiddenForPhone;
        mainContainer.appendChild(walkthroughContainer);
    }

    /**
     *
     * @param {string} containerClassName
     */
    function initialiseWalkthroughContainer(containerClassName) {
        const mainContainer = document.querySelector('.html-editor-user-options-container'),
            walkthroughContainer = document.createElement('div'),
            hiddenForPhone = containerClassName !== window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name && containerClassName !== window.PMW.emails.walkthrough.INTRODUCTION_MAIN_WALKTHROUGH.name ? 'hidden-tablet hidden-phone' : '';

        walkthroughContainer.id = 'email-editor-walkthrough-container ' + containerClassName;
        walkthroughContainer.className = 'js-walkthrough-container ' + containerClassName + '  ' + hiddenForPhone;
        mainContainer.appendChild(walkthroughContainer);
    }

    /**
     *
     * @param {string} userWalkThroughType
     */
    function initialiseWalkThroughListeners(userWalkThroughType) {
        PMW.onClick($('.user-walkthrough-popup' + '.' + userWalkThroughType + ' .js-next-button' + ':visible'), null, function () {
            let elem = $('.user-walkthrough-popup' + '.' + userWalkThroughType + ':visible').find('.walkthrough-container').not('._hidden'),
                nextElem = elem.next();
            elem.addClass('_hidden');
            nextElem.removeClass('_hidden');
            moveWalkthroughToNewPopup(nextElem, userWalkThroughType);
        });

        PMW.onClick($('.user-walkthrough-popup' + '.' + userWalkThroughType + ' .js-prev-button' + ':visible'), null, function () {
            let elem = $('.user-walkthrough-popup' + '.' + userWalkThroughType + ':visible').find('.walkthrough-container').not('._hidden'),
                prevElem = elem.prev();
            elem.addClass('_hidden');
            prevElem.removeClass('_hidden');
            moveWalkthroughToNewPopup(prevElem, userWalkThroughType);
        });

        PMW.onClick($('.js-success-button-popup'), null, function () {
            disableUserWalkThrough(userWalkThroughType)
        });

        PMW.onClick($('.js-skip-walkthrough'), null, function () {
            disableUserWalkThrough(userWalkThroughType)
        });
    }

    function initialiseStartWalkThroughListeners() {
        PMW.onClick($('.js-start-walkthrough'), null, function () {
            $('#introduction-main-user-walkthrough').addClass('_hidden');
            $('body').removeClass('walkthrough');
            editor.runCommand(window.PMW.emails.commands.walkthrough.OPEN_USER_MAIN_WALKTHROUGH_POPUP);
        });
        PMW.onClick($('.js-skip-walkthrough-introduction'), null, function () {
            $('#introduction-main-user-walkthrough').addClass('_hidden');
            $('body').removeClass('walkthrough');
            disableUserWalkThrough(window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name);
        });
    }

    /**
     *
     * @param {string} userWalkThroughType
     */
    function disableUserWalkThrough(userWalkThroughType) {
        $('.' + userWalkThroughType).addClass('_hidden');
        window.PMW.emails.IS_WALKTHROUGH_POPUP_OPEN = false;
        editor.runCommand(window.PMW.emails.commands.ENABLE_EDITOR_CONTROLS);
        switch (userWalkThroughType) {
            case window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name:
                disableMainWalkthroughPopup();
                break;

            case window.PMW.emails.walkthrough.ADD_SECTION.name:
                disableAddSectionPopup();
                break;

            case window.PMW.emails.walkthrough.ADD_TABLE.name:
                disableAddTablePopup();
                break;

            case window.PMW.emails.walkthrough.ADD_BUTTON.name:
                disableAddButtonPopup();
                break;

            case window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.name:
                disableAddSocialLinksPopup();
                break;

            case window.PMW.emails.walkthrough.ADD_LINK.name:
                disableAddLinkPopup();
                break;

            case window.PMW.emails.walkthrough.ADD_DESIGN.name:
                disableAddDesignPopup();
                break;
        }
    }

    function disableMainWalkthroughPopup() {
        window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.userHasSeen = true;
        if (!isUserLoggedIn()) {
            PMW.setCacheItem(window.PMW.emails.walkthrough.MAIN_WALKTHROUGH.name, '1');
        } else {
            PMW.write(PMW.util.site_url('emailmarketing/markEmailMainWalkthroughSeen'));
        }
    }

    function disableAddSectionPopup() {
        window.PMW.emails.walkthrough.ADD_SECTION.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen = true;

        if (!isUserLoggedIn()) {
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.ADD_SECTION.name, '1');
        } else {
            PMW.write(PMW.util.site_url('emailmarketing/markSectionWalkthroughSeen'), {
                isHierarchyLevelOne: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
            });
        }
    }

    function disableAddTablePopup() {
        window.PMW.emails.walkthrough.ADD_TABLE.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen = true;

        if (!isUserLoggedIn()) {
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.ADD_TABLE.name, '1');
        } else {
            PMW.write(PMW.util.site_url('emailmarketing/markTableWalkthroughSeen'), {
                isHierarchyLevelOne: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
            });
        }
    }

    function disableAddButtonPopup() {
        window.PMW.emails.walkthrough.ADD_BUTTON.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen = true;
        window.PMW.emails.walkthrough.ADD_LINK.userHasSeen = true;

        if (!isUserLoggedIn()) {
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.ADD_LINK.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.ADD_BUTTON.name, '1');
        } else {
            PMW.write(PMW.util.site_url('emailmarketing/markButtonWalkthroughSeen'), {
                isHierarchyLevelOne: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen,
                isLink: window.PMW.emails.walkthrough.ADD_LINK.userHasSeen
            });
        }
    }

    function disableAddSocialLinksPopup() {
        window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen = true;

        if (!isUserLoggedIn()) {
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.ADD_SOCIAL_LINKS.name, '1');
        } else {
            PMW.write(PMW.util.site_url('emailmarketing/markSocialWalkthroughSeen'), {
                isHierarchyLevelOne: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen
            });
        }
    }

    function disableAddLinkPopup() {
        window.PMW.emails.walkthrough.ADD_LINK.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen = true;

        if (!isUserLoggedIn()) {
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.ADD_LINK.name, '1');
        } else {
            PMW.write(PMW.util.site_url('emailmarketing/markLinkWalkthroughSeen'), {
                isHierarchyLevelOne: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen
            });
        }
    }

    function disableAddDesignPopup() {
        window.PMW.emails.walkthrough.ADD_DESIGN.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen = true;
        window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen = true;
        window.PMW.emails.walkthrough.ADD_LINK.userHasSeen = true;

        if (!isUserLoggedIn()) {
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.ADD_DESIGN.name, '1');
            PMW.setCacheItem(window.PMW.emails.walkthrough.ADD_LINK.name, '1');
        } else {
            PMW.write(PMW.util.site_url('emailmarketing/markDesignWalkthroughSeen'), {
                isHierarchyLevelOne: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_ONE.userHasSeen,
                isHierarchyLevelTwo: window.PMW.emails.walkthrough.HIERARCHY_LEVEL_TWO.userHasSeen,
                isLink: window.PMW.emails.walkthrough.ADD_LINK.userHasSeen
            });
        }
    }

    /**
     *
     * @param {HTMLElement} newElement
     * @param {string} userWalkThroughType
     */
    function moveWalkthroughToNewPopup(newElement, userWalkThroughType) {
        const modalContainer = $('.user-walkthrough-popup' + '.' + userWalkThroughType + ':visible'),
            stepNumber = newElement[0].getAttribute('data-step-number'),
            headerTitle = newElement[0].getAttribute('data-header-title'),
            totalSteps = modalContainer[0].getAttribute('data-total-steps'),
            isLastStep = parseInt(stepNumber) === parseInt(totalSteps),
            isFirstStep = stepNumber === '1';

        $('.js-step-number-walkthrough').html(stepNumber + ' / ' + totalSteps);
        $('.js-header-title-walkthrough').html(headerTitle);

        try {
            changePositionAndDimensionsOfPopup(modalContainer, newElement);
            handleFirstStepWalkthrough(isFirstStep);
            handleLastStepWalkthrough(isLastStep);
        } catch (e) {
            console.error(e);
            disableUserWalkThrough(userWalkThroughType);
        }
    }
}

/**
 *
 * @param modalContainer
 * @param newElement
 */
export function changePositionAndDimensionsOfPopup(modalContainer, newElement) {
    const positionContainerClassname = newElement[0].getAttribute('data-position-container'),
        positionOffsetLeft = newElement[0].getAttribute('data-left-offset'),
        positionOffsetTop = newElement[0].getAttribute('data-top-offset'),
        modalHeight = newElement[0].getAttribute('data-modal-height'),
        modalWidth = newElement[0].getAttribute('data-modal-width'),
        nextElementPosition = $('.' + positionContainerClassname).offset();

    modalContainer.css({
        "top": `${nextElementPosition.top + parseInt(positionOffsetTop)}px`, "left": `${nextElementPosition.left + parseInt(positionOffsetLeft)}px`
        , "width": `${modalWidth}px`, "height": `${modalHeight}px`
    });
}

/**
 *
 * @param {boolean} isLastStep
 */
export function handleLastStepWalkthrough(isLastStep) {
    const stepNumber = $('.js-step-number-walkthrough'),
        successButton = $('.js-success-walkthrough'),
        nextButton = $('.js-next-walkthrough'),
        skipLink = $('.js-skip-walkthrough');

    if (isLastStep) {
        successButton.removeClass('_hidden');
        nextButton.addClass('_hidden');
        skipLink.addClass('_hidden');
        stepNumber.removeClass('content-primary');
        stepNumber.addClass('color-success');

    } else if (nextButton.hasClass("_hidden")) {
        successButton.addClass('_hidden');
        nextButton.removeClass('_hidden');
        skipLink.removeClass('_hidden');
        stepNumber.addClass('content-primary');
        stepNumber.removeClass('color-success');
    }
}

/**
 *
 * @param {boolean} isFirstStep
 */
export function handleFirstStepWalkthrough(isFirstStep) {
    const prevButton = $('.js-prev-walkthrough'),
        stepNumber = $('.js-step-number-walkthrough');

    if (isFirstStep) {
        prevButton.addClass('_hidden');
        stepNumber.addClass('extra-spacing-left')
    } else if (prevButton.hasClass("_hidden")) {
        prevButton.removeClass('_hidden');
        stepNumber.removeClass('extra-spacing-left')
    }
}
